import axios from '../../plugins/axios-common';
import router from "@/router";
import axiosInstance from '../../plugins/axios-common';
import {v4 as uuidv4} from "uuid";

export default {
	namespaced: true,
	actions: {
		getSubmitCheckEmployeePresenceSmsCode(ctx, pload) {
			return new Promise((resolve, reject) => {
				axios({
					method: 'post',
					url: '/api/cash/shift/check-employee-presence/get-otp',
					data: pload,
				}).then((response) => {
					resolve(response)
				}).catch((e) => {
					reject(e)
				})
			})
		},
		checkSubmitCheckEmployeePresenceSmsCode(ctx, pload) {
			return new Promise((resolve, reject) => {
				axios({
					method: 'post',
					url: '/api/cash/shift/check-employee-presence/check-otp',
					data: pload,
				}).then((response) => {
					resolve(response)
				}).catch((e) => {
					reject(e)
				})
			})
		},
		async fetchShiftData(ctx) {
			return new Promise((resolve, reject) => {
				ctx.commit('updateLoading', true)
				axios("/api/cash/kkm/shiftstatus").then((res) => {
					const shift = res.data
					ctx.commit('updateShiftData', shift)
					ctx.commit('updateLoading', false)
					resolve(shift)
				}).catch((e) => {
					console.log('Error:', e)
					reject(e)
				})
			})
		},
		fetchShiftDataAxios (ctx) {
			return new Promise((resolve, reject) => {
				ctx.commit('updateLoading', true)
				axios({
					method: 'get',
					url: '/api/cash/kkm/shiftstatus',
				}).then((response) => {
					ctx.dispatch('fetchUserDataAxios', {}, {root:true}).then((resp) => {
						console.log('getMotivationData',resp)
						ctx.dispatch('motivation/getMotivationData', response.data.id, { root: true })
					})
					console.log('shiftstatus:', response.data)
					ctx.commit('updateShiftData', response.data)
					ctx.commit('updateAutoAcquiring', response.data.auto_acquiring)
					ctx.commit('updateLoading', false)
					if(response.data.opened){
						ctx.dispatch('fetchShiftInfo', response.data.id).then((shiftinfo)=>{
							response.data.shiftinfo = shiftinfo.data
							resolve(response.data)
						})
					} else {
						resolve(response.data)
					}
				}).catch((e) => {
					console.log(e.response.status)
					if(e.response.status === 401) {
						router.push('/login')
					}
					reject(e)
					ctx.commit('updateLoading', false)
				})
			})
		},
		fetchShiftOrders (ctx, value) {
			return new Promise((resolve, reject) => {
				axios.get('/api/cash/shift/' + value + '/orders').then((response) => {
					resolve(response.data)
				}).catch((e) => {
					reject(e)
				})
			})
		},
		fetchOrder (ctx, payload) {
			return new Promise((resolve, reject) => {
				const { shiftId, orderId } = payload
				axiosInstance.get(`/api/cash/shift/${shiftId}/orders/${orderId}`).then((resp) => {
					resolve(resp.data.data)
				}).catch((err) => {
					reject(err)
				})
			})
		},
		fetchCarLogo(ctx, payload) {
			return new Promise((resolve, reject) => {
				axiosInstance.get(`/cars-db/get-logo/${payload.carId}`).then((resp) => {
					resolve(resp.data.data)
				}).catch((err) => {
					reject(err)
				})
			})
		},
		openShift(ctx, payload) {
			return new Promise((resolve, reject) => {
				const body = {
					'employees': payload.employees,
				}
				const settings = {
					method: 'POST',
					data: body,
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
						'IdempotencyKey': uuidv4()
					}
				}
				axiosInstance("/api/cash/kkm/openshift", settings).then((resp) => {
					ctx.commit('updateShiftData', resp.data)
					this.dispatch('sendNotification', {quote: 'Открыта смена', type: 'info'})
					resolve('Открыта смена')
				}).catch((e) => {
					this.dispatch('sendNotification', {quote: 'Ошибка открытия смены', type: 'danger'})
					reject(e)
					// console.log('error on opening')
				})
			})
		},
		addEmployeesToShift(ctx, payload) {
			const body = {
				'employees': payload.employees,
			}
			const settings = {
				method: 'POST',
				data: body,
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				}
			}
			axiosInstance("api/cash/kkm/addemployeestoshift", settings).then((res) => {
				const shift = res.data
				ctx.commit('updateShiftData', shift)
				this.dispatch('sendNotification', {quote: 'Изменен состав смены', type: 'info'})
			})
		},
		async closeShift({commit, state}) {
			return new Promise((resolve, reject) => {
				const body = { shift_id: state.shift.id }
				const settings = {
					method: 'POST',
					url: '/api/cash/kkm/closeshift',
					data: body,
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'IdempotencyKey': uuidv4(),
					}
				}
				axiosInstance(settings).then((response) => {
					commit('updateShiftData', response.data)
					resolve(response)
				}).catch((error) => {
					reject(error.response)
				})
			})
		},
		fetchShiftInfo (ctx, shiftId) {
			return new Promise((resolve, reject) => {
				axios.get('/api/cash/shift/' + shiftId + '/status').then((response) => {
					ctx.commit('updateShiftInfo', response.data.data)
					resolve(response.data)
				}).catch((e) => {
					reject(e)
				})
			})
		},
		addAssistants(ctx, payload) {
			return new Promise((resolve, reject) => {
				const body = {
					'assistants': payload.assistants,
				}
				const settings = {
					method: 'POST',
					data: body,
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					}
				}
				axiosInstance("api/cash/kkm/addassist", settings).then((res) => {
					const shift = res.data
					ctx.commit('updateShiftData', shift)
					resolve('allOk')
				}).catch((e) => {
					reject(e)
				})
			})
		},
		attachEmployees(ctx, payload) {
			return new Promise((resolve, reject) => {
				const body = {
					'employees': payload.employees,
				}
				const settings = {
					method: 'POST',
					data: body,
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					}
				}
				axiosInstance('api/cash/kkm/attachemployee', settings).then((res) => {
					const shift = res.data
					ctx.commit('updateShiftData', shift)
					resolve('added')
				}).catch((e) => {
					reject(e)
				})
			})
		},
		detachEmployee(ctx, payload) {
			return new Promise((resolve, reject) => {
				const body = { 'type': payload.type, 'id': payload.id, 'amount': payload.amount }
				const settings = {
					method: 'POST',
					data: body,
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
					}
				}
				axiosInstance("api/cash/kkm/detachemployee", settings).then((res) => {
					const shift = res.data
					ctx.commit('updateShiftInfo', shift)
				}).then((resp) => {
					resolve(resp)
				}).catch((e) => {
					reject(e)
				})
			})
		},
		setContextModal ({commit}, newState) {
			commit('setContextModal', newState)
		},
	},
	mutations: {
		saveOrderInfo(state, orderInfo) {
			state.orderInfo = orderInfo
		},
		updateShiftData(state, shift) {
			state.shift = shift
		},
		updateLoading(state, loading) {
			state.loading = loading
		},
		updateShiftInfo(state, shiftInfo) {
			state.shiftInfo = shiftInfo
		},
		updateEmployeesInShift(state, employees) {
			state.employeesInShift = employees
		},
		updateMoneybox(state, moneybox) {
			state.moneybox = moneybox
		},
		updateMoneyboxEmployee(state, moneyboxEmployee) {
			state.moneyboxEmployee.chosenType = moneyboxEmployee.type
			state.moneyboxEmployee.chosenId = moneyboxEmployee.id
			state.moneyboxEmployee.chosenName = moneyboxEmployee.name
		},
		updateContextEmployee(state, contextEmployee) {
			state.contextEmployee.chosenType = contextEmployee.type
			state.contextEmployee.chosenId = contextEmployee.id
			state.contextEmployee.chosenName = contextEmployee.name
			state.contextEmployee.away = contextEmployee.away
		},
		updateAutoAcquiring(state, autoAcquiring) {
			state.autoAcquiring = autoAcquiring
		},
		setContextModal (state, newState) {
			state.contextModal = newState
		}
	},
	state: {
		loading: false,
		autoAcquiring: false,
		orderInfo: {},
		shift: {},
		shiftInfo: {},
		employeesInShift: {},
		moneybox: {},
		moneyboxEmployee: {
			chosenType: '',
			chosenId: '',
			chosenName: ''
		},
		contextEmployee: {
			chosenType: '',
			chosenId: '',
			chosenName: '',
			away: false
		},
		contextModal: false,
	},
	getters: {
		contextModal (state) {
			return state.contextModal
		},
		orderInfo(state) {
			return state.orderInfo
		},
		shiftData(state) {
			return state.shift
		},
		shiftLoading(state) {
			return state.loading
		},
		shiftInfo(state) {
			return state.shiftInfo
		},
		shiftWorkers(state) {
			return state.shiftInfo.workers?state.shiftInfo.workers.map(a => a.id):[]
		},
		shiftAssistants(state) {
			return state.shiftInfo.assistants?state.shiftInfo.assistants.map(a => a.id):[]
		},
		employeesInShift(state) {
			return state.employeesInShift
		},
		moneybox(state) {
			return state.moneybox
		},
		moneyboxEmployee(state) {
			return state.moneyboxEmployee
		},
		contextEmployee(state) {
			return state.contextEmployee
		},
		shiftAutoAcquiring(state) {
			return state.shift.auto_acquiring
		},
		autoAcquiring(state) {
			return state.autoAcquiring
		}
	}
}
